import { render, staticRenderFns } from "./DeliveryRequestDetail.vue?vue&type=template&id=6b7af56e"
import script from "./DeliveryRequestDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRequestDetail.vue?vue&type=style&index=0&id=6b7af56e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports